<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button
        class="button"
        :class="{
          'is-success': t.details.status === 'success',
          'is-danger-light': t.details.status === 'refused',
          'is-light': t.details.status === 'cancelled',
          'is-warning': t.details.status === 'error',
          'is-dark': t.details.status === 'refunded',
          'is-danger': t.details.status === 'chargeback',
          'is-light-green':
            t.details.status === 'billingPending' ||
            t.details.status === 'chargebackPaid'
        }"
        slot="trigger"
        @click.stop
      >
        {{
          t.details.status === "success"
            ? $t("transactions.statusSuccess")
            : t.details.status === "refused"
            ? $t("transactions.statusRefused")
            : t.details.status === "error"
            ? $t("transactions.statusError")
            : t.details.status === "cancelled"
            ? $t("transactions.statusCancelled")
            : t.details.status === "open"
            ? $t("transactions.statusOpen")
            : t.details.status === "refundedRequested"
            ? $t("transactions.statusRefundRequested")
            : t.details.status === "refunded"
            ? $t("transactions.statusRefunded")
            : t.details.status === "refundRefused"
            ? $t("transactions.statusRefundRefused")
            : t.details.status === "refundFailed"
            ? $t("transactions.statusRefundFailed")
            : t.details.status === "refundReversed"
            ? $t("transactions.statusRefundReversed")
            : t.details.status === "chargeback"
            ? $t("transactions.statusChargeback")
            : t.details.status === "chargebackPaid"
            ? $t("transactions.statusChargebackPaid")
            : "-"
        }}
      </button>
    </template>

    <b-dropdown-item
      aria-role="listitem"
      v-if="t.details.format === 'showroom'"
    >
      {{ $t("transactions.showroom") }}
      <br />
      <small>({{ $t("transactions.notCharged") }})</small>
    </b-dropdown-item>

    <b-dropdown-item v-else aria-role="listitem">
      <p>
        {{ paymentMethods }}
        <span v-if="t.details.origin !== 'vending'">
          ({{ $t("transactions.app") }})
        </span>
      </p>
    </b-dropdown-item>

    <hr
      v-if="!onlyCacauShowVendings"
      class="separator has-background-primary"
    />

    <div v-if="!onlyCacauShowVendings">
      <b-dropdown-item aria-role="listitem">
        <b>{{ $t("transactions.cart") }}: </b>
        {{ `${payments.currencySymbol}${formatMoney(t.cart.totalValue)}` }}
      </b-dropdown-item>

      <div
        v-if="
          (t.discounts.coupon && t.discounts.coupon.total) ||
            t.discounts.cashbackUsed
        "
      >
        <b-dropdown-item
          aria-role="listitem"
          v-if="t.discounts.coupon && t.discounts.coupon.total"
        >
          <b>(-) {{ $t("transactions.coupon") }}: </b>
          {{
            `${payments.currencySymbol}${formatMoney(t.discounts.coupon.total)}`
          }}
          <br />
          <small>
            {{
              t.discounts.coupon.type === "absolute"
                ? `--> ${t.discounts.coupon.name} ${
                    payments.currencySymbol
                  }${formatMoney(t.discounts.coupon.value)}`
                : t.discounts.coupon.type === "percentual"
                ? `--> ${t.discounts.coupon.name} ${t.discounts.coupon.value}%`
                : "?"
            }}
          </small>
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem" v-if="t.discounts.cashbackUsed">
          <b>(-) {{ $t("transactions.cashback") }}: </b>
          {{
            `${payments.currencySymbol}${formatMoney(t.discounts.cashbackUsed)}`
          }}
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem">
          <hr class="bill-separator has-background-elegant-black-3" />
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem">
          <b>{{ $t("transactions.totalToPay") }}: </b>
          {{
            `${payments.currencySymbol}${formatMoney(t.details.chargedValue)}`
          }}
        </b-dropdown-item>
      </div>

      <b-dropdown-item aria-role="listitem" v-if="t.details.prepaid">
        <b>{{ $t("transactions.credits") }}: </b>
        {{ `${payments.currencySymbol}${formatMoney(t.details.prepaid)}` }}
      </b-dropdown-item>

      <div v-if="t.rewards.cashbackAccumulated.total">
        <b-dropdown-item aria-role="listitem">
          <hr class="bill-separator has-background-elegant-black-3" />
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem">
          <b>(+) {{ $t("transactions.cashback") }}: </b>
          {{
            `${payments.currencySymbol}${formatMoney(
              t.rewards.cashbackAccumulated.total
            )}`
          }}
        </b-dropdown-item>
      </div>
    </div>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";

export default {
  mixins: [common, mask],

  props: ["t"],

  computed: {
    ...mapGetters(["payments", "onlyCacauShowVendings"]),

    paymentMethods() {
      let p = [];
      if (this.t.discounts.coupon) p.push(this.$t("transactions.coupon"));
      if (this.t.discounts.cashbackUsed)
        p.push(this.$t("transactions.cashback"));
      if (this.t.details.prepaid) p.push(this.$t("transactions.prepaid"));
      return p.join(" + ");
    }
  }
};
</script>

<style scoped>
.separator {
  height: 1px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.bill-separator {
  height: 1px;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}
</style>
